export default "__VITE_ASSET__BL10LoRp__"